import { isNil } from '../../utils';

import { HttpStatusCode } from '../other/http-status-code';

import { MobizHttpApiErrorResponse } from './mobiz-http-api-error-response.do';
import { SerializableObject } from './serializable-object';

export class MobizHttpErrorResponse extends SerializableObject {
  public status: number;
  public statusText: string;

  public info: MobizHttpApiErrorResponse;

  public get message(): string {
    const errorMessage: string = this.info.getMessage();
    // NOTE: In some cases, the HTTP error response contains an empty body or an unknown response.
    return errorMessage || this.statusText;
  }

  /**
   * TODO: TP-9476 Fix API response for situations where the OAuth token has expired.
   * TODO: Splint into: OAuthExpiredTokenError and use AccessDeniedError for a better API.
   */
  public isOAuthUnauthorizedError(): boolean {
    return this.status === HttpStatusCode.UNAUTHORIZED && this.info.isOAuthError();
  }

  /**
   * @inheritdoc
   */
  protected coercePropertyType(propertyName: string, propertyValue: unknown): unknown {
    if (isNil(propertyValue)) {
      return undefined;
    }
    switch (propertyName) {
      case 'info':
        return new MobizHttpApiErrorResponse(propertyValue);
      default:
        return propertyValue;
    }
  }

}
